import { render, staticRenderFns } from "./ProfilView.vue?vue&type=template&id=0edee9c2&"
import script from "./ProfilView.vue?vue&type=script&lang=js&"
export * from "./ProfilView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports